(() => {
 const money=(value,currency)=>new Intl.NumberFormat(document.documentElement.lang||'tr-TR',{style:'currency',currency}).format(value/100);
 function init(root){
  if(root.dataset.packageInitialized)return;root.dataset.packageInitialized='true';
  const currency=root.dataset.currency||'TRY';
  const palette=JSON.parse(root.querySelector('[data-izp-palette]').textContent);
  const dictionaries=JSON.parse(root.querySelector('[data-izp-translations]').textContent);
  const initialLanguage=(root.dataset.language||'tr').split('-')[0];
  let language=dictionaries[initialLanguage]?initialLanguage:'tr';
  let dict=dictionaries[language];const refreshers=[];
  const tr=(key,values={})=>Object.entries(values).reduce((result,[name,value])=>result.replaceAll('{'+name+'}',String(value)),dict.ui[key]||key);
  function translate(){
   dict=dictionaries[language];root.lang=language;root.dir=language==='ar'?'rtl':'ltr';
   root.querySelectorAll('[data-izp-text]').forEach(el=>el.textContent=tr(el.dataset.izpText));
   root.querySelectorAll('[data-izp-language]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.izpLanguage===language)));
   root.querySelectorAll('[data-izp-card]').forEach(card=>{
    const copy=dict.packages[card.dataset.packageKey];
    if(copy)card.querySelectorAll('[data-izp-package]').forEach(el=>el.textContent=copy[el.dataset.izpPackage]);
    card.querySelector('[data-izp-badge]').textContent=tr('badge_'+card.dataset.category);
    card.querySelector('[data-izp-count]').textContent=tr('count',{count:card.querySelector('[data-izp-count]').dataset.izpCount});
    const color=card.querySelector('[data-izp-color]');

   });refreshers.forEach(refresh=>refresh());
  }
  root.querySelectorAll('[data-izp-filter]').forEach(tab=>tab.addEventListener('click',()=>{
   root.querySelectorAll('[data-izp-filter]').forEach(t=>t.setAttribute('aria-pressed',String(t===tab)));
   root.querySelectorAll('[data-izp-card]').forEach(c=>{c.hidden=c.dataset.category!==tab.dataset.izpFilter;});
  }));
  root.querySelectorAll('[data-izp-card]').forEach(card=>{
   const tiers=JSON.parse(card.querySelector('[data-izp-tiers]').textContent);
   const variants=JSON.parse(card.querySelector('[data-izp-variants]').textContent);
   const select=card.querySelector('[data-izp-size]'),button=card.querySelector('[data-izp-buy]'),status=card.querySelector('[data-izp-status]'),form=card.querySelector('form');
   let busy=false;
   const colorInput=card.querySelector('[data-izp-color]'),colorGrid=card.querySelector('[data-izp-color-grid]'),colorPicker=card.querySelector('[data-izp-color-picker]');
   const colors=card.dataset.category==='tavan'?palette.filter(c=>c.code==='Beyaz'):[...palette];
   if(card.dataset.category==='yalitim')colors.push({code:'Şeffaf',hex:'transparent'},{code:'Siyah',hex:'#0A0A0A'});
   const colorName=code=>code==='Beyaz'?tr('white'):code==='Şeffaf'?tr('transparent'):code==='Siyah'?tr('black'):code;
   function updateColor(){
    const selected=colors.find(c=>c.code===colorInput.value)||colors[0];
    colorInput.value=selected.code;colorInput.dataset.hex=selected.hex;
    const dot=card.querySelector('[data-izp-color-dot]');dot.style.backgroundColor=selected.hex;
    dot.classList.toggle('is-transparent',selected.hex==='transparent');
    card.querySelector('[data-izp-color-name]').textContent=colorName(selected.code);
    [...colorGrid.children].forEach(chip=>{
     chip.textContent=colorName(chip.dataset.code);chip.setAttribute('aria-label',colorName(chip.dataset.code));
     chip.setAttribute('aria-pressed',String(chip.dataset.code===selected.code));
    });
   }
   colors.forEach(color=>{
    const chip=document.createElement('button');chip.type='button';chip.dataset.code=color.code;chip.className='izb-color-swatch';
    chip.style.backgroundColor=color.hex;
    if(color.hex==='transparent')chip.classList.add('is-transparent');
    else {const rgb=color.hex.slice(1).match(/../g).map(v=>parseInt(v,16));chip.style.color=(rgb[0]*.299+rgb[1]*.587+rgb[2]*.114)<150?'#fff':'#152235';}
    chip.addEventListener('click',()=>{colorInput.value=color.code;updateColor();colorPicker.open=false;colorPicker.querySelector('summary').focus();});
    colorGrid.append(chip);
   });
   colorPicker.addEventListener('keydown',event=>{if(event.key==='Escape'){colorPicker.open=false;colorPicker.querySelector('summary').focus();}});
   const sizeButtons=card.querySelector('[data-izp-size-buttons]');
   tiers.forEach((tier,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=tier.title;select.append(option);});
   if(sizeButtons){
    tiers.forEach((tier,i)=>{
     const chip=document.createElement('button');chip.type='button';chip.dataset.tierIndex=String(i);
     chip.addEventListener('click',()=>{select.value=String(i);status.textContent='';update();});sizeButtons.append(chip);
    });select.hidden=true;
   }
   const variant=()=>variants.find(v=>v.option1===tiers[Number(select.value)].title);
   function update(){
    updateColor();
    [...select.options].forEach((option,i)=>option.textContent=dict.sizes[tiers[i].title]||tiers[i].title);
    const tier=tiers[Number(select.value)],v=variant();
    if(sizeButtons)[...sizeButtons.children].forEach((chip,i)=>{
     chip.textContent=dict.sizes[tiers[i].title]||tiers[i].title;
     chip.setAttribute('aria-pressed',String(i===Number(select.value)));
    });
    const price=v?v.price:tier.price,regular=v?(v.compare_at_price||v.price):tier.regular;
    card.querySelector('[data-izp-contents]').textContent=tier.contents;
    card.querySelectorAll('[data-izp-component]').forEach(link=>{
     const item=(tier.items||[]).find(item=>item.handle===link.dataset.izpComponent);
     if(item){
      link.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(item.handle)+'?variant='+item.variantId;
      const kind=item.name.includes('Astar')?'primer':item.name.includes('Tavan')?'ceiling':card.dataset.category==='yalitim'?'insulation':card.dataset.category==='dis'?'exterior':'wall';
      const label=link.querySelector('[data-izp-product-type]'),size=link.querySelector('[data-izp-product-size]');
      if(label)label.textContent=tr('product_'+kind);if(size)size.textContent=item.size;
     }
    });
    const list=card.querySelector('[data-izp-breakdown]');list.replaceChildren();
    (tier.items||[]).forEach(item=>{
     const row=document.createElement('li'),name=document.createElement(item.handle?'a':'strong'),detail=document.createElement('span');
     name.textContent=tr('quantity',{quantity:item.quantity,name:item.name});
     if(item.handle)name.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(item.handle)+'?variant='+item.variantId;
     detail.textContent=item.size+' — '+(dict.roles[item.role]||item.role);
     row.append(name,detail);list.append(row);
    });
    card.querySelector('[data-izp-price]').textContent=money(price,currency);
    card.querySelector('[data-izp-regular]').textContent=money(regular,currency);
    button.disabled=busy||!v||!v.available;
    button.textContent=busy?tr('busy'):v?(v.available?tr('buy'):tr('sold')):tr('pending');
   }
   select.addEventListener('change',()=>{status.textContent='';update();});
   form.addEventListener('submit',async e=>{
    e.preventDefault();const v=variant();if(busy||!v?.available||!form.reportValidity())return;
    busy=true;update();status.textContent=tr('adding');
    try{
     const base=window.Shopify?.routes?.root||'/';
     const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:{'Boya rengi / kodu':card.querySelector('[data-izp-color]').value.trim(),'Renk HEX':colorInput.dataset.hex,'Paket içeriği':tiers[Number(select.value)].contents}}]})});
     const result=await response.json();if(!response.ok)throw Error(result.description||result.message||tr('error'));
     window.location.assign(root.dataset.cart);
    }catch(error){status.textContent=error.message||tr('connection');busy=false;update();}
   });refreshers.push(update);update();
  });translate();
 }
 const scan=scope=>{if(scope.matches?.('[data-izp-section]'))init(scope);scope.querySelectorAll('[data-izp-section]').forEach(init);};
 scan(document);document.addEventListener('shopify:section:load',e=>scan(e.target));
})();
